// extracted by mini-css-extract-plugin
export default {"formItem":"CourseCustomizeForm_formItem__Wd00o","label":"CourseCustomizeForm_label__8E26n"};